import React, {useState} from "react";
import {useTranslation} from "@unibuddy/intl";
import * as yup from "yup";
import {Box, Button, FormGroup, Text} from "@unibuddy/patron";

import DegreeAutocomplete from "shared/Register/components/DegreeAutocomplete/DegreeAutocomplete";

import {CustomAttributeField} from "../../../../../types/generated";
import {useUniversity} from "../../../UniversityProvider/UniversityProvider";
import {CustomAttributeType} from "./CustomAttributeConstants";
import {RegisterTwoFormValues} from "../RegisterPage2Form";
import {IntlNamespaces} from "../../../../../translations/types";
import {
    INTL_ADD_AREA_OF_STUDY,
    INTL_WHAT_DO_YOU_PLAN_TO_STUDY,
    INTL_DEGREE_SELECT_PLACEHOLDER_FOR_MOB,
    INTL_I_DONT_KNOW_YET,
} from "../../../../../translations/signup";
import {INTL_DEGREES_REQUIRED} from "../../../../../translations/validations";

type AreaOfStudyFormFieldProps = {
    values: RegisterTwoFormValues;
};

export function AreaOfStudyFormField({values}: AreaOfStudyFormFieldProps) {
    const [areaOfStudyUnknown, setAreaOfStudyUnknown] = useState<boolean>(false);

    const {t} = useTranslation([IntlNamespaces.SIGNUP, IntlNamespaces.VALIDATIONS]);
    const {slug, customAttributes} = useUniversity();

    const areaOfStudy = customAttributes.find(
        (attr: CustomAttributeField) => attr.type === CustomAttributeType.AREA_OF_STUDY,
    );

    if (!areaOfStudy) return null;

    if (areaOfStudyUnknown)
        return (
            <Box marginBottom="xsmall" display="flex" flexDirection="column" gap="xsmall">
                <Text weight="700">
                    {t(
                        `${IntlNamespaces.SIGNUP}:${INTL_WHAT_DO_YOU_PLAN_TO_STUDY.key}`,
                        INTL_WHAT_DO_YOU_PLAN_TO_STUDY.defaultValue,
                    )}
                </Text>
                <Button onClick={() => setAreaOfStudyUnknown(false)} block>
                    {t(
                        `${IntlNamespaces.SIGNUP}:${INTL_ADD_AREA_OF_STUDY.key}`,
                        INTL_ADD_AREA_OF_STUDY.defaultValue,
                    )}
                </Button>
            </Box>
        );

    let areaOfStudyValidation = yup.array().min(1);
    if (areaOfStudy?.required) {
        areaOfStudyValidation = areaOfStudyValidation.required(
            t(
                `${IntlNamespaces.VALIDATIONS}:${INTL_DEGREES_REQUIRED.key}`,
                INTL_DEGREES_REQUIRED.defaultValue,
            ),
        );
    }
    return (
        <Box marginBottom="xsmall">
            <FormGroup
                id="degrees"
                initialValue={[]}
                validation={areaOfStudyValidation}
                label={t(
                    `${IntlNamespaces.SIGNUP}:${INTL_WHAT_DO_YOU_PLAN_TO_STUDY.key}`,
                    INTL_WHAT_DO_YOU_PLAN_TO_STUDY.defaultValue,
                )}
            >
                <DegreeAutocomplete
                    name="degrees"
                    universitySlug={slug}
                    degreeLevel={values.degreeLevel}
                    required
                    placeholder={t(
                        `${IntlNamespaces.SIGNUP}:${INTL_DEGREE_SELECT_PLACEHOLDER_FOR_MOB.key}`,
                        INTL_DEGREE_SELECT_PLACEHOLDER_FOR_MOB.defaultValue,
                    )}
                    multiple
                />
            </FormGroup>
            <Button onClick={() => setAreaOfStudyUnknown(true)} link>
                {t(
                    `${IntlNamespaces.SIGNUP}:${INTL_I_DONT_KNOW_YET.key}`,
                    INTL_I_DONT_KNOW_YET.defaultValue,
                )}
            </Button>
        </Box>
    );
}
